import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../UI";
import { useUserContext } from "../../contexts/UserContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../UI/Alert/SuccessAlert";
import Label from "../UI/Label";
import Loader from "../UI/Loader/Loader";
import { Field, Form, Formik } from "formik";
import { createAtAudienceFromTealiumTaskSchema } from "../../schemas";
import Dropdown from "../UI/Dropdown/Dropdown";
import { getSavedTasks, saveTask, updateTask } from "../../utils/APIs";
import { useContentfulContext } from "../../contexts/ContentfulContext";
import { toast } from "react-toastify";
import InlineTooltip from "../UI/Tooltip/InlineTooltip";
import Tooltip from "../UI/Tooltip";

const CreateAtAudienceFromTealium = () => {
    const { userData } = useUserContext();
    const { pathname } = useLocation();
    const { saved_task_id } = useParams()
    const navigate = useNavigate()
    const { content } = useContentfulContext();

    const [showSuccess, setShowSuccess] = useState("");
    const [showError, setShowError] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();

    useEffect(() => {
        if (saved_task_id) getSavedTasksDataById()
    }, [])

    const getSavedTasksDataById = async () => {
        try {
            setLoading(true);
            const result = await getSavedTasks(
                userData?.token,
                userData?.selectedOrganization?.org_token,
                saved_task_id
            );
            setData(result.data[0]);
        } catch (error) {
            console.log("error getSavedTasksDataById: ", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            setShowError("");
            let result;
            if (saved_task_id) {
                const data = {
                    time_interval: values?.time_interval,
                    status: values?.status,
                    regex: values?.regex,
                    contains: values?.contains,
                    recipient_emails: values?.recipient_emails,
                    adobe_io_integration_id: values?.adobe_io_integration_id,
                    tealium_integration_id: values.tealium_integration_id,
                };
                result = await updateTask(
                    userData.token,
                    userData.selectedOrganization.org_token,
                    { id: saved_task_id, data }
                );
            } else {
                const data = {
                    feature_id: content.products.adobe_target.id,
                    saved_task_name: values.saved_task_name,
                    function_id: pathname.split('/').pop(),
                    tealium_integration_id: values.tealium_integration_id,
                    adobe_io_integration_id: values?.adobe_io_integration_id,
                    workspace_id: userData?.defaultWorkspace?._id,
                    time_interval: values.time_interval,
                    status: values.status,
                    contains: values?.contains,
                    recipient_emails: values?.recipient_emails,
                };
                result = await saveTask(
                    userData.token,
                    userData.selectedOrganization.org_token,
                    data
                );
            }
            toast.success(result.message);
            navigate("/functions/saved-tasks")
        } catch (error) {
            setShowError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setLoading(false);
        }
    }

    // Transform Adobe IO integrations for dropdown
    const adobeIoOptions = userData?.adobeIoIntegrations?.map(integration => ({
        value: integration._id,
        name: integration.integration_name
    })) || [];

    // Transform Tealium integrations for dropdown
    const tealiumOptions = userData?.tealiumIntegrations?.map(integration => ({
        value: integration._id,
        name: integration.tealium_api_name
    })) || [];

    return (
        <>
            <div className="w-full max-w-screen px-4 md:px-8 my-6">
                {loading && <Loader />}
                {showSuccess && (
                    <SuccessAlert disappearTime={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.timeout}>
                        {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.success}
                    </SuccessAlert>
                )}
                <div className="flex flex-col w-full lg:w-1/2 justify-center items-start">
                    <div className="space-y-4 md:space-y-6 w-full">
                        <Formik
                            enableReinitialize
                            initialValues={{
                                saved_task_name: data?.saved_task_name ? data?.saved_task_name : "",
                                time_interval: data?.time_interval || "",
                                status: data?.status || "",
                                contains: data?.contains || "",
                                email: "",
                                recipient_emails: data?.recipient_emails || [],
                                adobe_io_integration_id: data?.adobe_io_integration_id?._id || "",
                                tealium_integration_id: data?.tealium_integration_id?._id || "",

                            }}
                            validationSchema={() => createAtAudienceFromTealiumTaskSchema(content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT)}
                            onSubmit={handleSubmit}
                        >
                            {({ errors, touched, setFieldValue, values }) => (
                                // <Form>
                                //     <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-4">
                                //         {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.title}
                                //     </h2>
                                //     <p>{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.description}</p>
                                //     <div className="my-4">
                                //         <div className="relative">
                                //             <Field
                                //                 type="text"
                                //                 id="saved_task_name"
                                //                 name="saved_task_name"
                                //                 className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                //                 placeholder=" "
                                //                 disabled={saved_task_id}
                                //             />
                                //             <Label labelFor="saved_task_name">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.saved_task_name}</Label>
                                //             <Tooltip content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.saved_task_name} class_name="-right-8 top-1/2" />
                                //         </div>
                                //         {errors.saved_task_name && touched.saved_task_name ? (
                                //         <p className="mt-2 text-sm text-red-5">{errors.saved_task_name}</p>
                                //         ) : null}
                                //     </div>

                                //     <div className="my-4">
                                //         <div className="relative">
                                //             <Field
                                //                 type="text"
                                //                 id="contains"
                                //                 name="contains"
                                //                 className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                //                 placeholder=" "
                                //             />
                                //             <Label labelFor="contains">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.contains}</Label>
                                //             <Tooltip content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.contains} class_name="-right-8 top-1/2" />
                                //         </div>
                                //         {errors.contains && touched.contains ? (
                                //         <p className="mt-2 text-sm text-red-5">{errors.contains}</p>
                                //         ) : null}
                                //     </div>

                                //               <div className="my-4">
                                //                   <div className="relative w-full">
                                //                       <Dropdown
                                //                           width={100}
                                //                           isWidthInPercentage={true}
                                //                           initialValue={adobeIoOptions.find(x => x.value === values.adobe_io_integration_id)}
                                //                           items={adobeIoOptions}
                                //                           callback={(val) => setFieldValue("adobe_io_integration_id", val.value)}
                                //                       />
                                //                       <Label labelFor="adobe_io_integration_id">{"Adobe IO Integration"}</Label>
                                //                       <Tooltip
                                //                           content={"Select the Adobe IO integration to use for this task"}
                                //                           class_name="-right-8 top-1/2"
                                //                       />
                                //                   </div>
                                //                   {errors.adobe_io_integration_id && touched.adobe_io_integration_id ? (
                                //                       <p className="mt-2 text-sm text-red-5">{errors.adobe_io_integration_id}</p>
                                //                   ) : null}
                                //               </div>

                                //               <div className="my-4">
                                //                   <div className="relative w-full">
                                //                       <Dropdown
                                //                         width={100}
                                //                           isWidthInPercentage={true}
                                //                           initialValue={tealiumOptions.find(x => x.value === values.tealium_integration_id)}
                                //                           items={tealiumOptions}
                                //                           callback={(val) => setFieldValue("tealium_integration_id", val.value)}
                                //                       />
                                //                       <Label labelFor="tealium_integration_id">{"Tealium Integration"}</Label>
                                //                       <Tooltip
                                //                           content={"Select the Tealium integration to use for this task"}
                                //                           class_name="-right-8 top-1/2"
                                //                       />
                                //                   </div>
                                //                   {errors.tealium_integration_id && touched.tealium_integration_id ? (
                                //                       <p className="mt-2 text-sm text-red-5">{errors.tealium_integration_id}</p>
                                //                   ) : null}
                                //               </div>

                                //     <div className="my-4">
                                //         <div className="flex items-center content-center gap-3">
                                //             <div className="relative">
                                //                 <Dropdown 
                                //                     initialValue={content.CRON_TIME_INTERVAL.find(x => x.value == values.time_interval)}
                                //                     items={content.CRON_TIME_INTERVAL}
                                //                     callback={(val) => setFieldValue("time_interval", val.value)}
                                //                 />
                                //                 <Label labelFor="time_interval">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.time_interval}</Label>
                                //             </div>
                                //             <InlineTooltip content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.time_interval} />
                                //         </div>
                                //         {errors.time_interval && touched.time_interval ? (
                                //         <p className="mt-2 text-sm text-red-5">{errors.time_interval}</p>
                                //         ) : null}
                                //     </div>
                                //     <div className="my-4">
                                //         <div className="flex items-center content-center gap-3">
                                //             <div className="relative">
                                //                 <Dropdown 
                                //                     initialValue={content.LAMBDA_STATUS_VALUES.find(x => x.value == values.status)}
                                //                     items={content.LAMBDA_STATUS_VALUES}
                                //                     callback={(val) => setFieldValue("status", val.value)}
                                //                 />
                                //                 <Label labelFor="status">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.status}</Label>
                                //             </div>
                                //             <InlineTooltip content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.status}/>
                                //         </div>
                                //         {errors.status && touched.status ? (
                                //         <p className="mt-2 text-sm text-red-5">{errors.status}</p>
                                //         ) : null}
                                //     </div>
                                //     <div className="my-4">
                                //         <div className="relative">
                                //             <Field
                                //                 type="text"
                                //                 id="email"
                                //                 name="email"
                                //                 className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                //                 placeholder=" "
                                //                 onKeyDown={(e) => {
                                //                     if (e.key === 'Enter') {
                                //                         e.preventDefault();
                                //                         e.stopPropagation();
                                //                         if(!errors.email) {
                                //                             setFieldValue('recipient_emails', [...values.recipient_emails, e.target.value]);
                                //                             setFieldValue('email', '');
                                //                         }
                                //                     }
                                //                 }}
                                //             />
                                //             <Label labelFor="email">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.email}</Label>
                                //             <Tooltip content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.recipient_emails} class_name="-right-8 top-1/2" />
                                //         </div>
                                //         <p className="mt-2 text-sm ">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.note}</p>
                                //         {errors.email && touched.email ? (
                                //             <p className="mt-2 text-sm text-red-5">{errors.email}</p>
                                //         ) : null}
                                //         {!errors.email && errors.recipient_emails && touched.recipient_emails ? (
                                //         <   p className="mt-2 text-sm text-red-5">{errors.recipient_emails}</p>
                                //         ) : null}
                                //         {values.recipient_emails.length >0  && <ul className="max-h-[200px] max-w-[450px] overflow-y-auto my-4 border border-gray-2 rounded-lg ">
                                //             {values.recipient_emails.map((x, i) => (
                                //                 <li key={i} className="p-3 flex justify-between w-full border-b border-gray-2">
                                //                     {x}
                                //                     <button
                                //                         type="button"
                                //                         className="text-red-5"
                                //                         onClick={() => {
                                //                             const newRecipientEmails = [...values.recipient_emails];
                                //                             newRecipientEmails.splice(i, 1);
                                //                             setFieldValue('recipient_emails', newRecipientEmails);
                                //                         }}
                                //                     >x</button>
                                //                 </li>
                                //             ))}
                                //         </ul>}
                                //     </div>
                                //     {showError && <p className="my-2 text-sm text-red-5">{showError}</p>}
                                //     <PrimaryButton type="submit">
                                //         {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.submit_cta}
                                //     </PrimaryButton>
                                // </Form>


                                <Form>
                                    <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-4">
                                        {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.title}
                                    </h2>
                                    <p className="mb-6">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.description}</p>

                                    {/* Row 1: Task Name & Contains Filter */}
                                    <div className="flex flex-col md:flex-row gap-9 mb-4">
                                        <div className="w-full">
                                            <div className="relative">
                                                <Field
                                                    type="text"
                                                    id="saved_task_name"
                                                    name="saved_task_name"
                                                    className="block px-2.5 pb-2.5 pt-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                                    placeholder=" "
                                                    disabled={saved_task_id}
                                                />
                                                <Label labelFor="saved_task_name">
                                                    {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.saved_task_name}
                                                </Label>
                                                <Tooltip
                                                    content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.saved_task_name}
                                                    class_name="-right-6 top-1/2"
                                                />
                                            </div>
                                            {errors.saved_task_name && touched.saved_task_name && (
                                                <p className="mt-2 text-sm text-red-5">{errors.saved_task_name}</p>
                                            )}
                                        </div>

                                        <div className="w-full">
                                            <div className="relative">
                                                <Field
                                                    type="text"
                                                    id="contains"
                                                    name="contains"
                                                    className="block px-2.5 pb-2.5 pt-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                                    placeholder=" "
                                                />
                                                <Label labelFor="contains">
                                                    {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.contains}
                                                </Label>
                                                <Tooltip
                                                    content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.contains}
                                                    class_name="-right-6 top-1/2"
                                                />
                                            </div>
                                            {errors.contains && touched.contains && (
                                                <p className="mt-2 text-sm text-red-5">{errors.contains}</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Row 2: Adobe IO Integration & Tealium Integration */}
                                    <div className="flex flex-col md:flex-row gap-9 mb-4">
                                        <div className="w-full">
                                            <div className="relative w-full">
                                                <Dropdown
                                                    width={100}
                                                    isWidthInPercentage={true}
                                                    initialValue={adobeIoOptions.find((x) => x.value === values.adobe_io_integration_id)}
                                                    items={adobeIoOptions}
                                                    callback={(val) => setFieldValue("adobe_io_integration_id", val.value)}
                                                />
                                                <Label labelFor="adobe_io_integration_id">Adobe IO Integration</Label>
                                                <Tooltip
                                                    content="Select the Adobe IO integration to use for this task"
                                                    class_name="-right-6 top-1/2"
                                                />
                                            </div>
                                            {errors.adobe_io_integration_id && touched.adobe_io_integration_id && (
                                                <p className="mt-2 text-sm text-red-5">{errors.adobe_io_integration_id}</p>
                                            )}
                                        </div>

                                        <div className="w-full">
                                            <div className="relative w-full">
                                                <Dropdown
                                                    width={100}
                                                    isWidthInPercentage={true}
                                                    initialValue={tealiumOptions.find((x) => x.value === values.tealium_integration_id)}
                                                    items={tealiumOptions}
                                                    callback={(val) => setFieldValue("tealium_integration_id", val.value)}
                                                />
                                                <Label labelFor="tealium_integration_id">Tealium Integration</Label>
                                                <Tooltip
                                                    content="Select the Tealium integration to use for this task"
                                                    class_name="-right-6 top-1/2"
                                                />
                                            </div>
                                            {errors.tealium_integration_id && touched.tealium_integration_id && (
                                                <p className="mt-2 text-sm text-red-5">{errors.tealium_integration_id}</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Row 3: Time Interval & Status */}
                                    <div className="flex flex-col md:flex-row gap-9 mb-4">
                                        <div className="w-full">
                                            <div className="relative w-full">
                                                <Dropdown
                                                    width={100}
                                                    isWidthInPercentage={true}
                                                    initialValue={content.CRON_TIME_INTERVAL.find((x) => x.value == values.time_interval)}
                                                    items={content.CRON_TIME_INTERVAL}
                                                    callback={(val) => setFieldValue("time_interval", val.value)}
                                                />
                                                <Label labelFor="time_interval">
                                                    {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.time_interval}
                                                </Label>
                                                <Tooltip
                                                    content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.time_interval}
                                                    class_name="-right-6 top-1/2"
                                                />
                                            </div>
                                            {errors.time_interval && touched.time_interval && (
                                                <p className="mt-2 text-sm text-red-5">{errors.time_interval}</p>
                                            )}
                                        </div>

                                        <div className="w-full">
                                            <div className="relative w-full">
                                                <Dropdown
                                                    width={100}
                                                    isWidthInPercentage={true}
                                                    initialValue={content.LAMBDA_STATUS_VALUES.find((x) => x.value == values.status)}
                                                    items={content.LAMBDA_STATUS_VALUES}
                                                    callback={(val) => setFieldValue("status", val.value)}
                                                />
                                                <Label labelFor="status">
                                                    {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.status}
                                                </Label>
                                                <Tooltip
                                                    content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.status}
                                                    class_name="-right-6 top-1/2"
                                                />
                                            </div>
                                            {errors.status && touched.status && (
                                                <p className="mt-2 text-sm text-red-5">{errors.status}</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Row 4: Email Input (Full Width) */}
                                    <div className="my-4">
                                        <div className="relative">
                                            <Field
                                                type="text"
                                                id="email"
                                                name="email"
                                                className="block px-2.5 pb-2.5 pt-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                                placeholder=" "
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        if (!errors.email && values.email) {
                                                            setFieldValue("recipient_emails", [...values.recipient_emails, values.email]);
                                                            setFieldValue("email", "");
                                                        }
                                                    }
                                                }}
                                            />
                                            <Label labelFor="email">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.formLabels.email}</Label>
                                            <Tooltip
                                                content={content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.help_text.recipient_emails}
                                                class_name="-right-8 top-1/2"
                                            />
                                        </div>
                                        <p className="mt-2 text-sm ">{content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.note}</p>
                                        {errors.email && touched.email ? (
                                            <p className="mt-2 text-sm text-red-5">{errors.email}</p>
                                        ) : null}
                                        {!errors.email && errors.recipient_emails && touched.recipient_emails ? (
                                            <   p className="mt-2 text-sm text-red-5">{errors.recipient_emails}</p>
                                        ) : null}
                                        {values.recipient_emails.length > 0 && <ul className="max-h-[200px] max-w-[450px] overflow-y-auto my-4 border border-gray-2 rounded-lg ">
                                            {values.recipient_emails.map((x, i) => (
                                                <li key={i} className="p-3 flex justify-between w-full border-b border-gray-2">
                                                    {x}
                                                    <button
                                                        type="button"
                                                        className="text-red-5"
                                                        onClick={() => {
                                                            const newRecipientEmails = [...values.recipient_emails];
                                                            newRecipientEmails.splice(i, 1);
                                                            setFieldValue('recipient_emails', newRecipientEmails);
                                                        }}
                                                    >x</button>
                                                </li>
                                            ))}
                                        </ul>}
                                    </div>

                                    {showError && <p className="my-2 text-sm text-red-5">{showError}</p>}
                                     <div className="flex justify-end mt-6">
                                        <PrimaryButton type="submit">
                                            {content.CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.submit_cta}
                                        </PrimaryButton>
                                     </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateAtAudienceFromTealium;
